module.exports = __webpack_public_path__ + "img/clock.abcb26b3.svg";